export default "__VITE_ASSET__LTCbRhoO__"